module.exports = __webpack_public_path__ + "img/no-img.f1076150.png";